import React from 'react';
import { useNavigate } from 'react-router-dom';
import PitchSectionsNavigation from './PitchSectionsNavigation';
import PitchSectionEditor from './PitchSectionEditor';
import { AISuggestionPanel } from '../plans';
import { PREDEFINED_PITCH_SECTIONS } from '../../constants/pitchConstants';

const PitchEditor = ({
  currentPlan,
  sections,
  activeSection,
  activeSectionId,
  answers,
  communityTagsInput,
  savingDraft,
  aiLoading,
  ai,
  aiError,
  guide,
  usageLimits,
  generatingPitch,
  pitchResult,
  onSectionChange,
  onChangeAnswer,
  onApplyOption,
  onTagsChange,
  onSaveDraft,
  onSuggest,
  onGeneratePitch,
  onShowGuide,
  onCloseGuide,
  onCloseAi,
}) => {
  const navigate = useNavigate();

  if (!currentPlan) {
    return <p>Selecciona o crea un plan para construir tu pitch profesional.</p>;
  }

  const hasAnySectionComplete = sections.some((section) =>
    section.questions?.some((q) => (answers[q.id] || '').trim().length > 0),
  );

  const isPredefined = activeSection
    ? PREDEFINED_PITCH_SECTIONS.has(activeSection.section_title)
    : false;

  const handleViewPitch = () => navigate(`/plans/pitch/${currentPlan.slug}/result`);

  return (
    <div>
      {/* Header — estructura idéntica a PlanEditor */}
      <div className="plan-header">
        <div className="plan-header-left">
          <h1>{currentPlan.title}</h1>
          <span className="usage-badge">Pitch profesional · máx. 5 min</span>
        </div>
        {pitchResult && (
          <button className="view-action-plan-btn" onClick={handleViewPitch}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7l-3 3-1.5-1.5"/>
            </svg>
            Ver pitch generado
          </button>
        )}
      </div>

      {/* Etiquetas de comunidad — contexto global para todo el pitch, no por sección */}
      <div className="pitch-global-tags">
        <label className="pitch-global-tags-label" htmlFor="pitch-community-tags">
          Comunidad objetivo
        </label>
        <input
          id="pitch-community-tags"
          type="text"
          className="pitch-tags-field pitch-tags-field--global"
          value={communityTagsInput}
          onChange={onTagsChange}
          placeholder="Etiquetas de comunidad (ej: beneficiarios, aliados, funcionarios)"
          aria-label="Etiquetas de comunidad ICETEX — contexto global del pitch"
        />
      </div>

      {/* Layout — estructura idéntica a PlanEditor */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        <PitchSectionsNavigation
          sections={sections}
          activeSectionId={activeSectionId}
          answers={answers}
          generatingPitch={generatingPitch}
          hasPitchResult={!!pitchResult}
          hasAnySectionComplete={hasAnySectionComplete}
          onSectionChange={onSectionChange}
          onGeneratePitch={onGeneratePitch}
        />

        <div style={{ flex: 1, minWidth: 0 }}>
          <PitchSectionEditor
            activeSection={activeSection}
            answers={answers}
            savingDraft={savingDraft}
            aiLoading={aiLoading}
            guide={guide}
            usageLimits={usageLimits}
            onChangeAnswer={onChangeAnswer}
            onApplyOption={onApplyOption}
            onSaveDraft={onSaveDraft}
            onSuggest={onSuggest}
            onShowGuide={onShowGuide}
            onCloseGuide={onCloseGuide}
          />

          <AISuggestionPanel
            aiData={ai}
            aiError={aiError}
            isPredefined={isPredefined}
            predefinedLabel="Recomendaciones Pitch"
            onClose={onCloseAi}
          />
        </div>
      </div>
    </div>
  );
};

export default PitchEditor;
